import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ButtonComponent = class extends Mixins(MagicConfigMixin) {
  get buttonVariant() {
    if (!this.variant) {
      return "";
    }
    return `button--${this.variant}`;
  }
};
__decorateClass([
  Prop({
    validator(type) {
      return [
        "primary",
        "success",
        "alert",
        "error",
        "light",
        "transparent",
        ""
      ].indexOf(type) !== -1;
    },
    default: ""
  })
], ButtonComponent.prototype, "variant", 2);
__decorateClass([
  Prop({ type: String, default: "button" })
], ButtonComponent.prototype, "buttonTag", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "icon", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "left", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "right", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "hollow", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "round", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "large", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "small", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "smallExtraPadding", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "tiny", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "wide", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "noMargin", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "lessMargin", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "noPadding", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "lessPadding", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "addSpace", 2);
__decorateClass([
  Prop(Boolean)
], ButtonComponent.prototype, "loading", 2);
__decorateClass([
  Prop([Object, Number, String])
], ButtonComponent.prototype, "to", 2);
ButtonComponent = __decorateClass([
  Component({
    name: "ui-button"
  })
], ButtonComponent);

export default ButtonComponent;
